import { permissaoService } from "@/services/api/permissao.service";
import { pessoaService } from "@/services/api/PessoaService";
import { Permissao, Role, roleService } from "@/services/api/RoleService";
import { PessoaDTO } from "@/types/pessoa";

import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";

export function useUserRolesData() {
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState<PessoaDTO[]>([]);
  const [roles, setRoles] = useState<Role[]>([]);
  const [permissions, setPermissions] = useState<Permissao[]>([]);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const [rolesData, permissionsData, usersData] = await Promise.all([
        roleService.getRoles(),
        permissaoService.getPermissions(),
        pessoaService.getPessoas(),
      ]);

      setRoles(rolesData);
      setPermissions(permissionsData);
      setUsers(usersData);
    } catch (error) {
      console.error("Failed to load data", error);
      toast.error("Erro ao carregar dados iniciais.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { users, setUsers, roles, setRoles, permissions, loading, refreshUsers: fetchData };
}
